import React from "react";
import { Flex } from "rebass";
import { useRecoilState } from "recoil";
import { Button } from "../../../../Components/Button";

import { Title2 } from "../../../../Components/Text";

import { StudioSession } from "../../../../State/studioSession";

export const ClearConfirmationModal = ({ setModalOpen }: any) => {
  const [studioSession, setStudioSession] = useRecoilState(StudioSession);

  return (
    <>
      <Flex
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="flex-start"
        textAlign="left"
      >
        <Title2 mb={5}>
          Are you sure you want to clear your current cards?
        </Title2>
        <Flex pt={[2]} justifyContent="flex-start">
          <Button
            size="small"
            flex={true}
            mt={3}
            onClick={() => {
              setStudioSession({ ...studioSession, confirmedClear: true });
              setModalOpen(false);
            }}
          >
            Clear Cards
          </Button>
          <Button
            type="button"
            size="small"
            flex={true}
            classification="subtle"
            ml={4}
            mt={3}
            onClick={() => {
              setModalOpen(false);
            }}
          >
            Cancel
          </Button>
        </Flex>
      </Flex>
    </>
  );
};
